import * as React from 'react';
import { AddButton } from 'components/profile/AddButton';
import { Grid } from 'ui';
import { StoreType, useActions } from '@tock/shared/utils/connect';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import { isDefined } from 'utils/arrayUtils';
import { patronPreferencesSelector } from 'selectors/preferencesSelector';
import { useSelector } from 'react-redux';
import ExpandableList from 'components/ExpandableList';

interface Props {
  patronProfile: core.PatronProfile;
}

const ProfilePreferencesLists: React.FunctionComponent<Props> = ({ patronProfile }) => {
  const { patronAversions } = patronProfile;

  const { cuisineOptions, hospitalityOptions, dietaryRestrictionOptions } = useSelector(
    (state: StoreType) => patronPreferencesSelector(state)
  );
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={3}>
        <PreferenceList
          title="Preferred cuisines"
          addPromptText="cuisines"
          list={cuisineOptions.map((option) => option && option.text).filter(isDefined)}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <PreferenceList
          title="Hospitality preferences"
          addPromptText="preferences"
          list={hospitalityOptions.map((option) => option && option.text).filter(isDefined)}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <PreferenceList
          title="Dietary restrictions"
          addPromptText="restrictions"
          list={dietaryRestrictionOptions.map((option) => option && option.text).filter(isDefined)}
        />
        <Typography variant="caption" color="fgSubtle">
          Please also confirm dietary restrictions directly with restaurants.
        </Typography>
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <PreferenceList
          title="Additional dietary notes"
          addPromptText="dietary notes"
          list={patronAversions ? [patronAversions] : []}
        />
      </Grid>
    </Grid>
  );
};

interface PreferencesListProps {
  title: React.ReactNode;
  addPromptText: string;
  list: string[];
}

const PreferenceList: React.FunctionComponent<PreferencesListProps> = ({
  title,
  addPromptText,
  list,
}) => {
  const {
    actions: { patron: patronActions },
  } = useActions();
  if (list.length === 0) {
    return (
      <ExpandableList
        title={title}
        list={[
          [
            <AddButton
              itemText={addPromptText}
              onClick={patronActions.openEditPatronProfileModal}
            />,
          ],
        ]}
      />
    );
  } else {
    return <ExpandableList title={title} list={list} />;
  }
};

export default ProfilePreferencesLists;
